export default {"src":"/_next/static/media/docker.df0deb11.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};